import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';

@Component({
  selector: 'app-license-card',
  templateUrl: './license-card.component.html',
  styleUrls: ['./license-card.component.css']
})
export class LicenseCardComponent implements OnInit {

  constructor() { }

  @Input() license;
  @Output() userAction = new EventEmitter();
  @Output() copyAction = new EventEmitter();
  @Output() stopAction = new EventEmitter();  
  @Output() switchAction = new EventEmitter();



  ngOnInit() {
  }

  getUsers(id) {
    this.userAction.emit(id);

  }

  copy(licenseNo,evt) {
    let obj = {
      licenseNo : licenseNo,
      evt: evt
    }
    this.copyAction.emit(obj);

  }

  stop(evt) {
    this.stopAction.emit(evt);

  }

  switchMe(id,evt) {
    let obj = {
      id: id,
      evt: evt
    }
    this.switchAction.emit(obj);

  }

}
